var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"background":"#f39c12","point":"rgb(255, 237, 127)","tooltip":"page view","points":_vm.points}})}
var staticRenderFns = []

export { render, staticRenderFns }